<template>
  <div class>
      <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
          <span style="font-weight:600;color:#000; line-height: 10px;">电站信息</span>
      </div>
      <el-form :model="firstForm" :rules="firstRules" ref="firstForm" label-width="120px" style="width: 400px; margin-top: 20px;">
          <el-form-item label="电站名称" prop="stationName">
              <el-input
              v-model="firstForm.stationName"
              placeholder="请输入电站名称"
              ></el-input>
          </el-form-item>
          <el-form-item label="经纬度" prop="latAndlng">
              <el-input
              v-model="firstForm.latAndlng"
              placeholder="请输入经纬度"
              ></el-input>
          </el-form-item>
          <el-form-item label="邮政编码" prop="emailCode">
              <el-input
              v-model="firstForm.emailCode"
              placeholder="请输入邮政编码"
              ></el-input>
          </el-form-item>

          <el-form-item label="电站地址" prop="areaCode">
                <el-cascader
                  :options="optionsThree"
                  v-model="firstForm.areaCode"
                  placeholder="请选择省市区"
                  @change="handleChange"
                  ref="three"
                ></el-cascader>
          </el-form-item>
          <el-form-item label="" prop="address" style="width: 700px;">
              <el-row>
                  <el-col :span="12">
                          <el-input style=""
                          v-model="firstForm.address"
                          placeholder="请输入详细地址"
                          >
                      </el-input>
                  </el-col>
                <el-col :span="5">
                      <el-button type="primary" plain style="margin-left: 10px;" @click="isShowMapClick">地图定位</el-button>
                </el-col>
              </el-row>
          </el-form-item>
          <el-form-item v-show="isShowMap" label="" style="width: 1000px;">
            <div id="container">
            </div>
            <div>当前定位：{{newAddress}}</div>
          </el-form-item>
          <el-form-item style="display: flex; flex-direction: column; text-align: center">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="onSubmit(true)">保存</el-button>
          </el-form-item>
      </el-form>
  </div>
</template>
<script>
import { regionData } from "element-china-area-data";
let map = null; //高德地图
export default {
  name: "xiugaidianzhan",
  components: {},
  data() {
    return {
      optionsThree: regionData, //省市区数据
      firstForm: {
        stationName: "",
        latAndlng:"",
        emailCode:"",
        areaCode: "",
        address: "",
        stationLat: 0.0,
        stationLng: 0.0,
      },
      firstRules: {
        stationName: [
          { required: true, message: '请输入电站名称', trigger: 'blur' },
        ],
        latAndlng: [
          { required: true, message: '请输入经纬度', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '请选择邮政编码', trigger: 'change' }
        ],
        areaCode: [
          { required: true, message: '请选择电站地址', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
      },
      isShowMap: false,
      newAddress: "",
      city: "", //省市区三级联动
      token: window.localStorage.getItem("token"),
      id:''
    };
  },
  computed: {},
  methods: {

    cancel(){
      this.$router.go(-1);
    },
    onSubmit(){

    },
    handleChange() {
      this.city = this.$refs.three.getCheckedNodes()[0].pathLabels.join(",")
      this.firstForm.areaCode = this.firstForm.areaCode.join(',')
    },


    isShowMapClick() {

      this.isShowMap = true;
      let address = this.city + this.form.address
      this.markLocation('container', address)
    },

    markLocation(mapId, address) {
        AMap.plugin('AMap.Geocoder', () => {
            var geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: '全国'
            })
              //创建地图
              map = new AMap.Map(mapId, {
                //mapStyle: 'amap://styles/grey',
                zoom: 13,
                center: [120.220876, 33.423722]
              });
              geocoder.getLocation(address, (status, result) => {
                  if (status === 'complete' && result.info === 'OK') {

                      // 经纬度
                      var lng = result.geocodes[0].location.lng;
                      var lat = result.geocodes[0].location.lat;
                      // 添加标记
                      let marker = new AMap.Marker({
                          position: new AMap.LngLat(lng, lat),   // 经纬度
                      });
                      map.add(marker); //加载点
                      map.setFitView(); //缩放至地图

                      geocoder.getAddress([lng,lat], (status, result) => {
                        if (status === 'complete' && result.info === 'OK') {
                            // result为对应的地理位置详细信息
                          console.log(result.regeocode.formattedAddress)
                          this.newAddress = result.regeocode.formattedAddress + '(' + lng + ',' + lat + ')'
                          this.firstForm.stationLat = lat
                          this.firstForm. stationLng = lng
                        }
                      })

                  } else {
                      console.log('定位失败', status);
                  }
              });

              //地图点击事件
              map.on("click", (e) => {
                map.clearMap();//清理地图
                  let lng = e.lnglat.getLng(); //获取经度
                  let lat = e.lnglat.getLat(); //获取纬度
                  var lnglat = [lng, lat]
                  //marker点
                  let marker = new AMap.Marker({
                    position: lnglat,
                    offset: new AMap.Pixel(-13, -30)
                  });
                  map.add(marker); //加载点
                  map.setFitView(); //缩放至地图
                  geocoder.getAddress(lnglat, (status, result) => {
                    if (status === 'complete' && result.info === 'OK') {
                        // result为对应的地理位置详细信息
                        console.log(result.regeocode.formattedAddress)
                        this.newAddress = result.regeocode.formattedAddress + '(' + lnglat[0] + ',' + lnglat[1] + ')'
                        this.firstForm.stationLat = lnglat[1]
                        this.firstForm. stationLng = lnglat[0]
                    }
                  })
              });
        });
    },
  },
  mounted() {
    // if(this.id){
    //   let data={
    //     id:this.id
    //   };
    //   this.$store.dispatch('form/handle',{
    //     url:'',
    //     data:data,
    //     callback:resp=>{
    //       console.log(resp,3333);
    //       // this.firstForm.stationName = resp.stationName
    //     }
    //   })
    // }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发

};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/reviseInterConStation.vue